import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const FastTranslate = forwardRef<SVGSVGElement | null, IconFilledProps>(function FastTranslate({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 4.92893C22.9763 8.83417 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83417 1.02369 15.1658 1.02369 19.0711 4.92893ZM18.0104 5.98959C21.3299 9.30905 21.3299 14.691 18.0104 18.0104C14.691 21.3299 9.30905 21.3299 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M13.6718 9.416L11.8522 17.9483C11.803 18.179 11.5991 18.344 11.3632 18.344H9.8566C9.53883 18.344 9.30167 18.0514 9.36742 17.7406L11.1278 9.416H8.42088C8.10172 9.416 7.86427 9.12104 7.93241 8.80925L8.24186 7.39325C8.29204 7.16366 8.49533 7 8.73033 7H16.7467C17.0659 7 17.3033 7.29496 17.2352 7.60675L16.9257 9.02275C16.8756 9.25234 16.6723 9.416 16.4373 9.416H13.6718Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.92882 4.92833C8.83399 1.02316 15.1661 1.02331 19.0714 4.92833C22.9766 8.83358 22.9766 15.1657 19.0714 19.0709C15.1662 22.9762 8.83406 22.9762 4.92882 19.0709C1.0238 15.1657 1.02365 8.8335 4.92882 4.92833ZM8.73058 6.99962C8.49561 6.99966 8.29247 7.16362 8.2423 7.39318L7.93273 8.80919C7.86467 9.12089 8.10199 9.41551 8.42101 9.41564H11.128L9.3673 17.7408C9.30194 18.0514 9.53915 18.3431 9.85656 18.3434H11.3634C11.5993 18.3434 11.8034 18.1786 11.8526 17.9479L13.672 9.41564H16.4376C16.6725 9.41564 16.8755 9.25239 16.9259 9.02306L17.2355 7.60704C17.3036 7.29529 17.0663 6.99969 16.7472 6.99962H8.73058Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'fast-translate-icon-svg'} iconRender={iconRender} {...props} />;
});

export default FastTranslate;
